import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Internal Formly FieldType Component
 * Used internally by CheckboxWrapperComponent and Formly forms.
 * Do not use this directly - use CheckboxWrapperComponent instead.
 */
@Component({
  selector: 'era-formly-checkbox-field',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormlyModule],
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> {
  get required(): boolean {
    return this.props.required || false;
  }

  get disabled(): boolean {
    return this.props.disabled || false;
  }

  get description(): string | undefined {
    return this.props.description;
  }

  get labelPosition(): 'left' | 'right' {
    return this.props.labelPosition || 'right';
  }

  get labelWidth(): string | undefined {
    return this.props.labelWidth;
  }
}
